import { AfterViewInit, Directive, ElementRef, HostListener, inject } from '@angular/core';

/** Grows a textarea to fit its content — no internal scrollbar, ever. */
@Directive({
  selector: 'textarea[appAutoGrow]',
  standalone: true,
})
export class AutoGrowDirective implements AfterViewInit {
  private readonly el = inject(ElementRef<HTMLTextAreaElement>);

  ngAfterViewInit(): void {
    // Let Angular finish writing the ngModel-bound value before measuring scrollHeight.
    setTimeout(() => this.resize());
  }

  @HostListener('input')
  @HostListener('focus')
  onChange(): void {
    this.resize();
  }

  private resize(): void {
    const ta = this.el.nativeElement;
    ta.style.height = 'auto';
    ta.style.height = `${ta.scrollHeight}px`;
  }
}
